import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    OnInit,
} from '@angular/core';
import { MenuItem } from '../interfaces/menu-item.interface';
import { trackById } from '../../../../utils/track-by';
import icPerson from '@iconify/icons-ic/twotone-person';
import icSettings from '@iconify/icons-ic/twotone-settings';
import icAccountCircle from '@iconify/icons-ic/twotone-account-circle';
import icListAlt from '@iconify/icons-ic/twotone-list-alt';
import icCheckCircle from '@iconify/icons-ic/twotone-check-circle';
import icAccessTime from '@iconify/icons-ic/twotone-access-time';
import icDoNotDisturb from '@iconify/icons-ic/twotone-do-not-disturb';
import icOfflineBolt from '@iconify/icons-ic/twotone-offline-bolt';
import icChevronRight from '@iconify/icons-ic/twotone-chevron-right';
import icArrowDropDown from '@iconify/icons-ic/twotone-arrow-drop-down';
import icBusiness from '@iconify/icons-ic/twotone-business';
import icVerifiedUser from '@iconify/icons-ic/twotone-verified-user';
import icLock from '@iconify/icons-ic/twotone-lock';
import icNotificationsOff from '@iconify/icons-ic/twotone-notifications-off';
import { Icon } from '@visurel/iconify-angular';
import { PopoverRef } from '../../../../components/popover/popover-ref';
import { User } from '../../../../../app/entities/user.entity';
import { UserStore } from '../../../../../app/stores/user.store';

import { LoaderService } from '@interceptors/loader/loader.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from '@app/auth/auth.service';
import { MsalAngularService } from '@services/msal-angular.service';

export interface OnlineStatus {
    id: 'online' | 'away' | 'dnd' | 'offline';
    label: string;
    icon: Icon;
    colorClass: string;
}

@Component({
    selector: 'vex-toolbar-user-dropdown',
    templateUrl: './toolbar-user-dropdown.component.html',
    styleUrls: ['./toolbar-user-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarUserDropdownComponent implements OnInit {
    user: User;

    items: MenuItem[] = [
        {
            id: '1',
            icon: icAccountCircle,
            label: 'My Profile',
            description: 'Personal Information',
            colorClass: 'text-teal',
            route: '/profile',
        },
        /*
		{
		  id: '2',
		  icon: icMoveToInbox,
		  label: 'My Inbox',
		  description: 'Messages & Latest News',
		  colorClass: 'text-primary',
		  route: '/apps/chat'
		},*/
        {
            id: '3',
            icon: icListAlt,
            label: 'Projects',
            description: 'Tasks & Active Projects',
            colorClass: 'text-amber',
            route: '/projects',
        },
        /*{
		  id: '4',
		  icon: icTableChart,
		  label: 'Billing Information',
		  description: 'Pricing & Current Plan',
		  colorClass: 'text-purple',
		  route: '/pages/pricing'
		}*/
    ];

    statuses: OnlineStatus[] = [
        {
            id: 'online',
            label: 'Online',
            icon: icCheckCircle,
            colorClass: 'text-green',
        },
        {
            id: 'away',
            label: 'Away',
            icon: icAccessTime,
            colorClass: 'text-orange',
        },
        {
            id: 'dnd',
            label: 'Do not disturb',
            icon: icDoNotDisturb,
            colorClass: 'text-red',
        },
        {
            id: 'offline',
            label: 'Offline',
            icon: icOfflineBolt,
            colorClass: 'text-gray',
        },
    ];

    activeStatus: OnlineStatus = this.statuses[0];

    trackById = trackById;
    icPerson = icPerson;
    icSettings = icSettings;
    icChevronRight = icChevronRight;
    icArrowDropDown = icArrowDropDown;
    icBusiness = icBusiness;
    icVerifiedUser = icVerifiedUser;
    icLock = icLock;
    icNotificationsOff = icNotificationsOff;

    constructor(
        private cd: ChangeDetectorRef,
        private authService: AuthService,
        private loaderService: LoaderService,
        private popoverRef: PopoverRef<ToolbarUserDropdownComponent>,
        private userStore: UserStore,
        private router: Router,
        private location: Location,
        private msalAngularService: MsalAngularService,
    ) {}

    ngOnInit() {
        this.user = this.userStore.getUser();
    }

    setStatus(status: OnlineStatus) {
        this.activeStatus = status;
        this.cd.markForCheck();
    }

    close() {
        this.popoverRef.close();
    }

    async logout() {
        this.loaderService.show();
        this.userStore.logout();
        // await this.authService.logout();
        await this.msalAngularService.logout();
        this.loaderService.hide();
        this.close();
    }

    navigate(route: string) {
        const currentUrl = this.location.path();
        this.router
            .navigate([route], {
                queryParams: {},
            })
            .then(() => {
                if (currentUrl.includes('profile')) {
                    window.location.reload();
                }
            });
    }
}
